export default __webpack_public_path__ + "static/media/sub_nft_03.0ef10aa0.gif";